var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"block-title",class:{

    'col-lg-12': true

   

}},[(_vm.title[_vm.title.length-1] != ' ')?_c('hr',{staticClass:"d-none d-md-flex mt-4"}):_vm._e(),_vm._v(" "),_c('h3',{staticStyle:{"padding":"1rem .2rem","color":"#262626"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb7f3c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockTitle.vue
// module id = null
// module chunks = 